import React from 'react';

const KPICards = ({ stats, role }) => {
    const formatCurrency = (amount) => {
        return `₹${amount.toLocaleString('en-IN')}`;
    };

    const isCoAdmin = role === 'co-admin';

    // Masked Value Component
    const MaskedValue = () => (
        <span style={{ fontSize: '18px', color: '#ccc', letterSpacing: '2px' }}>●●●●●</span>
    );

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '30px' }}>

            {/* Today Sales */}
            <div className="dashboard-card kpi-card">
                <div style={{ fontSize: '13px', color: '#888', fontWeight: '600', marginBottom: '8px' }}>TODAY SALES</div>
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1F1F1F', marginBottom: '4px' }}>
                    {isCoAdmin ? <MaskedValue /> : formatCurrency(stats.todaySales)}
                </div>
                <div style={{ fontSize: '13px', color: '#B8860B', fontWeight: '500' }}>
                    {stats.todayBillCount} Bills
                </div>
            </div>

            {/* Pending Dues - Still Visible for Collections */}
            <div className="dashboard-card kpi-card">
                <div style={{ fontSize: '13px', color: '#888', fontWeight: '600', marginBottom: '8px' }}>PENDING DUES</div>
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#d32f2f', marginBottom: '4px' }}>
                    {formatCurrency(stats.totalPending)}
                </div>
                <div style={{ fontSize: '13px', color: '#d32f2f', fontWeight: '500' }}>
                    {stats.pendingBillCount} Bills Pending
                </div>
            </div>

            {/* Month Sales */}
            <div className="dashboard-card kpi-card">
                <div style={{ fontSize: '13px', color: '#888', fontWeight: '600', marginBottom: '8px' }}>MONTH SALES</div>
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1F1F1F', marginBottom: '4px' }}>
                    {isCoAdmin ? <MaskedValue /> : formatCurrency(stats.monthSales)}
                </div>
                {!isCoAdmin && (
                    <div style={{ fontSize: '13px', color: '#2e7d32', fontWeight: '600' }}>
                        ↑ 12% <span style={{ color: '#aaa', fontWeight: 'normal' }}>vs last month</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default KPICards;
